import styled from 'styled-components';

import { media, rem, themed } from '@/shared/ui/core';

export const ErrorScreenContainer = styled.div.attrs({
  className: 'ErrorScreenContainer',
})`
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const ErrorScreen = styled.div.attrs({
  className: 'ErrorScreen',
})`
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
`;

export const ErrorScreenTitle = styled.div.attrs({
  className: 'ErrorScreen__Title',
})`
  display: flex;
  justify-content: center;

  .Title {
    font-size: 1.25rem;
    font-weight: bold;
    color: ${themed('primary.text')};
    margin-bottom: ${rem(8)};
  }
`;

export const ErrorScreenMessage = styled.div.attrs({
  className: 'ErrorScreen__Message',
})`
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .Text {
    font-size: 1rem;
    text-align: center;
    color: ${themed('primary.text')};
    margin-bottom: 0.25rem;
    display: block;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const ErrorScreenButton = styled.div.attrs({
  className: 'ErrorScreen__Button',
})`
  display: flex;
  justify-content: center;

  .component__button {
    font-size: 1rem;
    min-width: 12rem;
    padding: 0.25rem 1rem;

    @media ${media.mobileMin} {
      width: 12rem;
    }

    @media ${media.tabletMin} {
      width: auto;
    }
  }
`;

export const ErrorScreenIlustration = styled.div.attrs({
  className: 'ErrorScreenIlustration',
})`
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  display: block;

  img {
    width: 100%;
    margin: auto;
    display: block;
    max-width: 14rem;
  }
`;

export const Exception = styled.div``;

export const Pre = styled.pre`
  background-color: rgba(0, 128, 255, 0.04);
  font-size: 0.875rem;
  margin: 2.5rem auto 0;
  max-height: 30rem;
  max-width: 100%;
  overflow: auto;
  padding: 1rem;
  white-space: pre-wrap;
  width: 46.875rem;

  code {
    color: #333333;

    div {
      color: #999999;
      margin-bottom: 1rem;
    }
  }
`;
